





















import { Component, Mixins } from 'vue-mixin-decorator';
import { SlotMixin } from '@/mixins/SlotMixin';
import { Prop, Watch } from 'vue-property-decorator';
import RadioTree from '@/components/RadioTree.vue';
@Component({
  components: { RadioTree }
})
export default class CategorySelect extends Mixins<SlotMixin>(SlotMixin) {
  @Prop() private current?:number;
  @Prop() private currentArray?:Array<any>;
  @Prop() public data?:Array<any>;
  public change:number = 0;
  public computedData?:Array<any> = [];
  @Watch('current')
  public onCurrentChange (newVal:number) {
    this.change = newVal;
  }
  public computedCurrentArray () {
    if (this.currentArray) {
      return [...this.currentArray];
    } else {
      return [];
    }
  }
  @Watch('data', { deep: true })
  public onDataChange (newVal:Array<any>) {
    this.computedData = [...newVal];
  }
  created () {
    if (this.current) { this.change = this.current; }
    if (this.data) {
      this.computedData = [...this.data];
    }
  }
}
